import fasElyon1 from "./fas-elyon (1).png";
import fasElyon2 from "./fas-elyon (2).png";
import fasElyon3 from "./fas-elyon (3).png";
import fasElyon4 from "./fas-elyon (4).png";

const faselyon = [fasElyon1, fasElyon2, fasElyon3, fasElyon4];

export default faselyon;
